import type React from "react";
import { ReactComponent as Svg } from "./assets/share.svg";
import * as styles from "./Icon.module.scss";

type ShareProps = React.SVGProps<SVGSVGElement>;

export const Share = ({ className, ...props }: ShareProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
